import { applyLayerOrder } from "./MapLayerUtils";
import { IMPACT_LAYERS } from "./polygonStyles";

const layerIds = (cfg) => {
  const ids = [`${cfg.source}-fill`, `${cfg.source}-line`];
  if (cfg.dot) ids.push(`${cfg.source}-dot`);
  return ids;
};

export const setImpactLayersVisibility = (map, visible) => {
  Object.entries(IMPACT_LAYERS).forEach(([key, cfg]) => {
    layerIds(cfg).forEach((id) => {
      if (map.getLayer(id)) {
        map.setLayoutProperty(
          id,
          "visibility",
          visible[key] === false ? "none" : "visible",
        );
      }
    });
  });
};

/** data = the full API response (impacts.data). Pass null to clear. */
export const syncImpactLayers = (map, data, visible = {}) => {
  Object.values(IMPACT_LAYERS).forEach((cfg) => {
    const fc = data?.[cfg.prop];
    const [fillId, lineId, dotId] = layerIds(cfg);

    if (!fc) {
      layerIds(cfg).forEach((l) => map.getLayer(l) && map.removeLayer(l));
      if (map.getSource(cfg.source)) map.removeSource(cfg.source);
      return;
    }

    if (map.getSource(cfg.source)) {
      map.getSource(cfg.source).setData(fc);
      return;
    }

    map.addSource(cfg.source, { type: "geojson", data: fc });
    map.addLayer({
      id: fillId,
      type: "fill",
      source: cfg.source,
      paint: { "fill-color": cfg.fill, "fill-opacity": cfg.fillOpacity },
    });
    map.addLayer({
      id: lineId,
      type: "line",
      source: cfg.source,
      paint: { "line-color": cfg.line, "line-width": cfg.lineWidth },
    });

    // symbol layers on polygons are placed at the polygon's center automatically
   if (cfg.dot) {
  map.addLayer({
    id: dotId,
    type: "symbol",
    source: cfg.source,
    maxzoom: 16, 
    layout: {
      "text-field": "▼",
      "text-allow-overlap": true,
      "text-ignore-placement": true,
"text-size": ["interpolate", ["linear"], ["zoom"], 8, 56, 11, 44, 14, 28, 16, 16],
    },
    paint: {
      "text-color": cfg.dot,
      "text-halo-color": "#ffffff",
      "text-halo-width": 1,
    },
  });
}
  });

   applyLayerOrder(map);
  setImpactLayersVisibility(map, visible);
};